import { DayOfTheWeek } from "@api/graphql/generated/generated-types";
import { RouteStop, RouteTemplateSummary } from "../types/routeTemplateTypes";
import { WEEK_BASED_TYPES } from "@src/routeTemplates/constants/scheduleConstants";

const toRouteStop = (entry: any): RouteStop => ({
  id: entry.stopTemplateId,
  shipmentTemplateId: entry.stopTemplate.shipmentTemplateId,
  sequenceNumber: entry.sequenceNumber,
  orderDisplayId: entry.stopTemplate.shipmentTemplate?.order?.displayId ?? null,
  endCustomerId: entry.stopTemplate.shipmentTemplate?.order?.endCustomer?.id ?? null,
  endCustomerName: entry.stopTemplate.shipmentTemplate?.order?.endCustomer?.companyName ?? null,
  streetAddress: entry.stopTemplate.streetAddress,
  city: entry.stopTemplate.city,
  companyName: entry.stopTemplate.companyName,
  contactName: entry.stopTemplate.contactName,
  type: entry.stopTemplate.type,
  orderRecurrenceWeekDays: (() => {
    const detail = entry.stopTemplate.shipmentTemplate?.order?.recurrenceDetail;
    if (!detail || !WEEK_BASED_TYPES.has(detail.scheduleType)) return [];
    return (detail.weeklySchedule?.weekDays ?? []) as DayOfTheWeek[];
  })(),
  lng: entry.stopTemplate.lngLat?.lng ?? null,
  lat: entry.stopTemplate.lngLat?.lat ?? null,
  serviceType: entry.stopTemplate.shipmentTemplate?.order?.serviceType ?? null,
  timeWindow: entry.stopTemplate.timeWindow ?? null,
  packageMovements: entry.stopTemplate.packageMovements ?? [],
});

const toRouteTemplateSummary = (node: any): RouteTemplateSummary => ({
  id: node.id,
  name: node.name,
  displayId: node.displayId,
  stops: (node.stopTemplatesInSequence ?? []).map(toRouteStop),
  schedule: node.schedule ?? null,
  enabledCommunicationTypes: node.enabledCommunicationTypes ?? [],
});

export const formatRouteTemplatesResponse = (data: any): RouteTemplateSummary[] =>
  data?.routeTemplatesPaginated?.edges
    ?.flatMap((edge: any) => (edge?.node ? [edge.node] : []))
    .map(toRouteTemplateSummary) ?? [];
